import React from "react"
import { useSnackbar } from "notistack"
import { RoboConfig } from "../../../services/apiRobo"
import { erroMsg } from "../components/comum"

/** Logs internos do robô (rail 📜) — lê /robosc/logs. */
export function Logs() {
    const { enqueueSnackbar } = useSnackbar()
    const [itens, setItens] = React.useState<any[]>([])
    const [nivel, setNivel] = React.useState("")
    const [carregando, setCarregando] = React.useState(false)

    const carregar = React.useCallback(async () => {
        setCarregando(true)
        try {
            const r = await RoboConfig.listarLogs({ nivel: nivel || undefined, limite: 300 })
            setItens(Array.isArray(r) ? r : r?.items || [])
        } catch (e) {
            enqueueSnackbar(erroMsg(e), { variant: "error" })
        } finally {
            setCarregando(false)
        }
    }, [nivel, enqueueSnackbar])

    React.useEffect(() => {
        carregar()
    }, [carregar])

    return (
        <section className="panel active" style={{ display: "block" }}>
            <div className="panel-actions">
                <h3 style={{ margin: 0 }}>📜 Logs</h3>
                <select value={nivel} onChange={e => setNivel(e.target.value)}>
                    <option value="">Todos os níveis</option>
                    <option value="INFO">INFO</option>
                    <option value="WARN">WARN</option>
                    <option value="ERROR">ERROR</option>
                </select>
                <button className="ghost" onClick={carregar}>
                    ↻ Atualizar
                </button>
            </div>
            {carregando && <div className="muted small" style={{ padding: 12 }}>Carregando…</div>}
            {!carregando && itens.length === 0 && <div className="empty">Sem logs.</div>}
            <div style={{ padding: "0 12px 12px", overflowX: "auto" }}>
                <table style={{ width: "100%" }}>
                    <thead>
                        <tr>
                            <th>Quando</th>
                            <th>Nível</th>
                            <th>Módulo</th>
                            <th>Etapa</th>
                            <th>Mensagem</th>
                        </tr>
                    </thead>
                    <tbody>
                        {itens.map(l => (
                            <tr key={l.id}>
                                <td style={{ whiteSpace: "nowrap" }}>{fmt(l.criadoEm)}</td>
                                <td>
                                    <span className="chip" style={corNivel(l.nivel)}>
                                        {l.nivel || "—"}
                                    </span>
                                </td>
                                <td>{l.modulo || "—"}</td>
                                <td>{l.etapa || "—"}</td>
                                <td style={{ wordBreak: "break-word" }}>{l.mensagem}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </section>
    )
}

function fmt(v: any): string {
    if (!v) return ""
    try {
        return new Date(v).toLocaleString("pt-BR", {
            day: "2-digit",
            month: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
        })
    } catch {
        return ""
    }
}
function corNivel(n: string): React.CSSProperties {
    if (n === "ERROR") return { background: "var(--sp-bg)", color: "var(--sp)" }
    if (n === "WARN") return { background: "var(--by-bg)", color: "var(--by)" }
    return {}
}

export default Logs
